export const EVENT_FETCH_PRICES = 'fetch_prices';
export const EVENT_PRICES_VISIBLE = 'prices_visible';
export const EVENT_PRICES_FETCHED = 'prices_fetched';

export const EVENT_PICK_FARES = 'pick_fares';
export const EVENT_PICK_FLIGHT = 'pick_flight';
export const EVENT_PICK_ROOMS = 'pick_rooms';
export const EVENT_PICK_HOTEL_UPGRADES = 'pick_hotel_upgrades';
export const EVENT_PICK_ADDITIONAL_SERVICES = 'pick_additional_services';
export const EVENT_PICK_RENTAL_CAR = 'pick_rental_car';
export const EVENT_ENTER_TRAVELLER = 'enter_traveller';
export const EVENT_ENTER_CONTACTPERSON = 'enter_contactperson';
export const EVENT_FINAL_OVERVIEW = 'final_overview';
export const EVENT_ENTERED_COMMENTARY = 'entered_commentary';

export const EVENT_SELECT_ITEM = 'select_item';
export const EVENT_VIEW_ITEM_LIST = 'view_item_list';

export const EVENT_ADD_PAYMENT_INFO = 'add_payment_info';

// INSPECTING EVENTS
export const EVENT_INSPECT_HOTEL_UPGRADE = 'inspect_hotel_upgrade';
export const EVENT_INSPECT_RENTAL_CAR = 'inspect_rental_car';
export const EVENT_INSPECT_FLIGHT = 'inspect_flight';

// PICKED EVENTS
export const EVENT_PICKED_FARE = 'picked_fare';
export const EVENT_PICKED_FLIGHT = 'picked_flight';
export const EVENT_PICKED_ROOM = 'picked_room';
export const EVENT_PICKED_HOTEL_UPGRADE = 'picked_hotel_upgrades';
export const EVENT_PICKED_ADDITIONAL_SERVICES = 'picked_additional_services';
export const EVENT_PICKED_RENTAL_CARS = 'picked_rental_cars';

export const LOCAL_STORAGE_KEY_CHECKOUT_FUNNEL = 'checkoutFunnel';
